import { useSelector } from 'react-redux';
import { ICONS } from '../icons';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import { ASSISTANT_TYPES } from '../constants';

import scss from '../scout-new/components/generation-section/GenerationForm.module.scss';

const useTypeOptions = (selector) => {
  const typeOptions = useSelector(selector) || [];

  const mappedIcons = {
    [ASSISTANT_TYPES.FILE]: {
      icon: ICONS.SaveFile,
      isStrokeIcon: false,
      iconClassName: scss.typeDropdownIconRed,
    },
    [ASSISTANT_TYPES.TEXT]: {
      icon: ICONS.T,
      isStrokeIcon: true,
      iconClassName: scss.typeDropdownIconGreen,
    },
    CHAT: {
      icon: ChatBubbleOutlineRoundedIcon,
      isStrokeIcon: true,
      iconClassName: scss.typeDropdownIconYellow,
    },
  };

  return typeOptions?.map((assistant) => ({
    value: assistant.id,
    label: assistant.name,
    icon: mappedIcons[assistant.type].icon,
    isStrokeIcon: mappedIcons[assistant.type].isStrokeIcon,
    iconClassName: mappedIcons[assistant.type].iconClassName,
    ...assistant,
  }));
};

export default useTypeOptions;
